/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Ecken',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Nach verifizierten Ankündigungen, Ressourcen und Richtlinien suchen',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filter',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Platzhaltertext',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    'Passen Sie die für Ihre Leser sichtbare Aufforderung an',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Suchleiste mit Filtern hinzufügen',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Abgerundet',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Quadrat',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Füllfarbe',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Textfarbe',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Stile',
  'company-hub.search-extension.custom-search-config-panel.title': 'Benutzerdefinierte Suche',
  'company-hub.search-extension.manifest.default-placeholder-text':
    'Nach verifizierten Ankündigungen, Ressourcen und Richtlinien suchen',
  'company-hub.search-extension.manifest.macro-description': 'Suchleiste mit Filtern hinzufügen',
  'company-hub.search-extension.manifest.macro-title': 'Benutzerdefinierte Suche',
  'company-hub.search-extension.more-button': 'Weitere Ergebnisse anzeigen',
};
